<template>
  <div class="page f-2 report-page">
    <div class="report-area">
      <template v-for="item in reportsList">
        <reportBox :key="item.id" :reportInfo="item"></reportBox>
      </template>
    </div>
  </div>
</template>

<script>
import movie_reportsApi from "../api/movie_reportsApi.js";
import reportBox from "../components/report/reportBox";
import { clone, trim, debounce } from "lodash";
export default {
  name: "report",
  components: {
    reportBox
  },
  props: {},
  data() {
    return {
      reportApi: new movie_reportsApi(),
      reportsList: []
    };
  },
  computed: {},
  methods: {
    async searchReport() {
      let res = await this.reportApi.searchMovieReports();
      if (res.code !== 200 || res.status !== true) {
        this.$message({
          showClose: true,
          message: "获取往期报告失败",
          type: "error"
        });
        return;
      }
      this.reportsList = res.data;
    },
    tabPageSetting() {
      let statusCode = this.$route.query.statusCode;
      if (statusCode) {
        //有statusCode,均是点击页签进入，根据statusCode从store中拿取数据，并且不再需要pushTab
        this.$store.commit("tabpage/setCurrentTabByStatusCode", {
          statusCode: statusCode
        });
        let tabpageInfo = this.$store.getters[
          "tabpage/getCurrentTabStatusInfo"
        ];
        return;
      }
      this.$store.commit("tabpage/pushTab", {
        title: "往期报告",
        pathname: this.$route.name || "notfound",
        pathquery: Object.assign({}, this.$route.query),
        // pathparams: Object.assign({}, this.$route.params),
        type: "report",
        statusInfo: {
          mainMovie: undefined,
          movieList: undefined,
          filters: {}
        }
      });
    }
  },
  watch: {},
  async created() {
    this.tabPageSetting();
    this.$store.commit("movie/setMainMovie", {
      id: undefined
    });
    if (this.$store.getters["user/isLogined"]) {
      await this.searchReport();
    }
  }
};
</script>

<style lang="scss" scoped>
.report-page {
  background-color: #f9f9f9;
  // height: 100%;
  position: relative;
  overflow-y: scroll;
  padding: 0 20px;
  padding-top: 20px;
  min-width: 800px;
}
.report-area {
  padding: 20px 0;
  background-color: #ffffff;
}
</style>
